var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app-bar',{attrs:{"app":"","color":"primary","height":"80px"}},[_c('v-toolbar-title',{staticClass:"white--text"},[_c('v-img',{attrs:{"width":"200","src":require("../assets/img/uwalogo.png")}})],1),_c('v-spacer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }